export default {
  general: {
    to: 'to',
    none: 'None'
  },
  navMenu: {
    movies: 'movies',
    manage: 'manage',
    logout: 'logout'
  },
  pages: {
    movies: 'Universal Inbox'
  },
  compositions: {
    searchPlaceholder: 'Search for Compositions',
    filter: 'filter',
    filterInfoTitle: 'Filter - Movies',
    sortBy: 'Sorted by',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    view: 'View',
    viewFields: {
      all: 'all',
      sample: 'sample'
    },
    sortFields: {
      urgency: 'Relevance',
      other: 'other'
    },
    dcpStatusTitle: 'DCP Status',
    kdmStatusTitle: 'KDM Status',
    dcpStatus: {
      downloaded: 'Downloaded',
      pending: 'Pending',
      cancelled: 'Cancelled',
      dispatched: 'Shipped',
      pending_cancellation: 'Pending Cancellation',
      queued: 'Queued',
      failed: 'Failed',
      error: 'Failed',
      succeeded: 'Succeeded',
      executing: 'Downloading...',
      scheduled: 'Scheduled for Download',
      downloading: 'Downloading...',
      expired: 'Failed',
      intransit: 'In Transit',
      outfordelivery: 'Out For Delivery',
      attemptfail: 'Delivery AttemptFail',
      delivered: 'Delivered',
      exception: 'Delivery Exception'
    },
    kdmStatus: {
      emailed: 'Emailed',
      generated: 'Available',
      failed: 'Failed',
      inprogress: 'In Progress',
      success: 'Available'
    },
    viewCreditOffset: 'Credits: %{value}',
    noCreditOffset: 'No Credit Offset',
    theatres: 'Theatres',
    screens: 'Screens',
    theatre: 'Theatre',
    screen: 'Screen',
    multipleValidities: 'Multiple Validities',
    downloadKDMs: 'Download KDMs',
    creditOffset: 'Credit Offset',
    kdmDetails: 'KDM Details',
    assetDetails: 'Asset Details',
    name: 'Composition Name',
    status: 'Status',
    downloadAll: 'Download All',
    validity: 'Validity',
    multipleEmails: 'Multiple Emails',
    download: 'Download',
    markers: {
      ffec: 'FFEC',
      ffmc: 'FFMC'
    },
    cplMarkers: 'CPL Markers',
    creditsOffset: 'Credits Offset',
    standByServer: 'Standby Server',
    no_compositions: 'No Compositions',
    attributes: {
      language: 'Language',
      subtitleLanguage: 'Subtitle Language',
      mainCaption: 'Main Caption',
      ratings: 'Ratings',
      type: 'Type',
      dciStandard: 'DCI Standard',
      closedSubtitles: 'Closed Subtitles',
      frameRate: 'Frame Rate',
      audioFormats: 'Audio Formats',
      resolution: 'Resolution',
      closedCaptions: 'Closed Captions',
      stereoType: 'Stereo Type',
      aspectRatio: 'Aspect Ratio'
    },
    kdmDeliveryEmail: 'KDM Delivery Email',
    emailKDMS: 'Email KDMs',
    enterEmailAddress: 'Enter Email Addresses',
    email: 'Email',
    sendKDMEmailError: {
      empty: 'Atleast one email is required',
      invalidEmail: 'Invalid Email',
      send: 'Error in sending KDM Email'
    },
    sendKDMEmailSuccess: 'KDM Email\'s sent',
    kdm: 'KDM',
    dcp: 'DCP',
    dcpDownloadCompleted: 'Completed',
    trackingInfo: 'Tracking Info'
  },
  filterLabel: {
    theatre: 'Theatre'
  },
  theatre: {
    screen: 'Screen',
    theatres: 'theatres',
    chains: 'chains',
    no_theatres: 'No Theatres available',
    theatre: 'Theatre',
    filterByTheatres: 'Filter by Theatres',
    searchPlaceholder: 'Search for theatres you manage'
  },
  errors: {
    fetchCompositions: 'Error in loading compositions',
    fetchTheatres: 'Error in loading theatres',
    fetchUser: 'Error in loading user information',
    downloadKDMs: 'Error in KDM download',
    NoDownloadKDMs: 'No KDMs to download',
    fetchTheatreInfo: 'Error in loading theatre info'
  },
  shipmentStatuses: {
    Pending: 'Pending',
    InfoReceived: 'In Transit',
    InTransit: 'In Transit',
    OutForDelivery: 'Out For Delivery',
    AttemptFail: 'Delivery Attempt Failed',
    Delivered: 'Delivered',
    Exception: 'Delivery Exception',
    Expired: 'Expired'
  }
}



// WEBPACK FOOTER //
// ./src/app/locale/en.js